import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { Signal } from '../models/Signal';
import { SignalsConfigurationService } from './signalsconfiguration.service';
import { CloseSignal } from '../models/CloseSignal';
import { HttpParams } from '@angular/common/http';
import { StrategyStats } from '../models/StrategyStats';


@Injectable()
export class SignalsService {
  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService,
    private configuration: SignalsConfigurationService) { }

  public Create(signal: Signal): Observable<object> {
    return this.executeService.ExecuteWithToken('post', this.configuration.GetQbitiaApiUrl(), null, signal)
      .pipe(
        catchError(this.errorHandler.handleError<object>('SignalsService_Create', null))
      );
  };

  public Update(signal: CloseSignal): Observable<object> {
    return this.executeService.ExecuteWithToken('put', this.configuration.GetApiBoUrl() + "api/v1/Signal/CloseTrade", null, signal)
      .pipe(
        catchError(this.errorHandler.handleError<object>('SignalsService_Update', null))
      );
  };

  public GetActiveStrategies(): Observable<object[]> {
    return this.executeService.Execute('get', this.configuration.GetSignalsApiUrl() + "en/api/v2/Strategies", null, null)
      .pipe(
        map(response => this.filterStrategies(response)),
        catchError(this.errorHandler.handleError<string[]>('SignalsService_GetStrategies', null))
      );
  }

  filterStrategies(strategies) {
    return strategies.filter(function (strategy) {
      if (strategy.isActive == true)
        return strategy;
    })
      .map(function (strategy) {
        let result = { id: strategy.id, name: strategy.name};
        return result;
      });
  }

  public GetStatsByStrategy(strategyId: string, params: HttpParams): Observable<StrategyStats> {
    return this.executeService.Execute('get', this.configuration.GetSignalsApiUrl() + "en/api/v2/Stats/" + strategyId + "/strategy", params, null)
      .pipe(
        catchError(this.errorHandler.handleError<object>('SignalsService_GetStrategies', null))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/services/signals.service.ts